import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M3_PointersAndArrays = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Pointers and Arrays"
    videos={[
      "https://www.youtube.com/embed/ibj_AKOxpHo",
    ]}
    takeaways={[
      {
        text: "Mainly, coding questions are expected from this topic.",
      },
    ]}
    questions={[
      
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M3_PointersAndArrays;
